import { useSelector } from 'react-redux';

/**
 * Dark mode from Redux app settings (same source as ThemeProvider),
 * with DOM fallback for safety.
 */
const useDarkMode = () => {
  const appDarkMode = useSelector((state) => state.appSettings?.appDarkMode);

  if (typeof appDarkMode === 'boolean') {
    return appDarkMode;
  }

  if (typeof document === 'undefined') {
    return false;
  }

  return (
    document.documentElement.getAttribute('data-bs-theme') === 'dark' ||
    document.body.classList.contains('dark-mode')
  );
};

export default useDarkMode;
